import EmptyState from "../store/emptyState";
import { HeaderActionConstants } from "../action-constants";
import globalReducerHelper from "./globalReducerHelper";

const {
  TOGGLE_DROP_DOWN,
  CLOSE_MENU,
  SET_BODY_CLASS_NAME,
  SET_BETS_COUNT,
  SET_HEADER_HEIGHT,
  COLLAPSE_CROSS_ACTIVITY
} = HeaderActionConstants;

const header = (state = EmptyState.header, action) => {
  const { type, payload } = action;

  switch (type) {
    case TOGGLE_DROP_DOWN:
      return Object.assign({}, state, {
        dropDownExpand: !state.dropDownExpand
      });
    case CLOSE_MENU: {
      if (!!state.dropDownExpand) {
        return Object.assign({}, state, {
          dropDownExpand: !state.dropDownExpand
        });
      } else {
        return state;
      }
    }
    case SET_BODY_CLASS_NAME: {
      return Object.assign({}, state, {
        bodyClassName: action.payload
      });
    }
    case SET_BETS_COUNT: {
      return Object.assign({}, state, {
        betsCount: action.payload
      });
    }
    case SET_HEADER_HEIGHT: {
      return Object.assign({}, state, {
        headerHeight: action.payload
      });
    }

    case COLLAPSE_CROSS_ACTIVITY: {
      return Object.assign({}, state, {
        isCollapsedCrossActivity: action.payload
      });
    }
    default:
      return globalReducerHelper(
        state,
        type,
        payload && payload.header,
        EmptyState.header
      );
  }
};

export default header;
